/**
 * Created by Jew on 5/18/2017.
 */
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {animate, style, transition, trigger} from '@angular/animations';
import {IdexService} from 'app/idex.service';
import {MomentPipe} from 'app/shared/moment.pipe';
import {TranslateService} from '@ngx-translate/core';
import {ShareToEmailComponent} from '../share-to-email/share-to-email.component';
import {Toast} from 'app/shared/toast/toast';
import {Path} from 'app/shared/path';
import {ConfirmDialogComponent} from '../../e-signature/confirm-dialog/confirm-dialog.component';

declare const facebook: string;
declare const app_secret: string;

@Component({
   selector: 'app-sharing',
   animations: [
      trigger('slide', [
         transition(':enter', [
            style({height: 0}),
            animate('400ms ease-in', style({height: '*'}))
         ]),
         transition(':leave', [
            style({height: '*'}),
            animate('400ms ease-out', style({height: 0}))
         ])
      ])
   ],
   templateUrl: './sharing.component.html',
   styleUrls: ['./sharing.component.css']
})
export class SharingComponent implements OnInit {
   @ViewChild('btndone') button: MatButton;
   // private key = 'private zDOX key';
   shareType = 'Public';
   access = 'View';
   showMessage = false;
   advanced = false;
   link: string;
   item_share: any;
   pre_download: boolean;
   expiration: any;
   date: any;
   private timer: any;
   searchFocused: boolean;
   searchResult = [];
   people: any;
   peopleId: any;
   list_people = [];
   exp_date: any;
   error_date: string;
   error_password: string;
   hint: string;
   tomorrow: any;
   role = 'Admin';
   password: string;
   checkbox_password = false;
   forward = false;
   fb_app_id = facebook;
   app_secret = app_secret;
   isSite = false;
   isDisabled = false;
   userAllowShare = false;
   currentUser: any;
   myFile = false;
   isNotify = false;

   constructor(private dialog: MatDialog, public service: IdexService, private translate: TranslateService,
               public dialogRef: MatDialogRef<SharingComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
               private toast: Toast) {                  

   }

   ngOnInit() {

      const date = new Date();
      date.setDate(date.getDate() + 1);
      this.tomorrow = date;
      this.currentUser = JSON.parse(localStorage.getItem('idex-user'));
      this.getShare();
      this.role = this.data.role ? this.data.role : 'Admin';
      this.isSite = this.data.isSite ? this.data.isSite : !(this.data.tin === undefined || this.data.tin === '');
      this.isDisabled = this.data.isDisabled ? this.data.isDisabled : false;
      this.myFile = this.data.myFile ? this.data.myFile : false;
   }

   getShare() {
      this.service.share(this.data.id)
         .subscribe(data => {
            this.item_share = data;
            this.shareType = data.type;
            let pageShare = 'share-public/';
            if (this.shareType !== 'Public') {
               pageShare = 'share/';
            }
            this.link = Path.getAppUrl() + pageShare + data.id;
            this.updateHint();
            this.access = data.access ? data.access : this.access;
            this.pre_download = data.download;
            this.password = data.password ? data.password : undefined;
            this.checkbox_password = data.password ? true : false;
            this.date = data.expiry ? new Date(data.expiry) : data.expiry;
            this.exp_date = data.expiry;
            this.list_people = data.permissions || [];
            for (let i = 0; i < this.list_people.length; i++) {
               this.list_people[i].isDisabled = this.isDisabled;
               this.list_people[i].isNew = false;
            }
            if (this.isDisabled) {
               this.userAllowShare = true;
            }
            this.advanced = data.type !== 'Public' || !data.download || data.expiry || data.password;
         });
   }

   shareTypeChange(shareSelector) {
      const linkShare = Path.getAppUrl() + 'share/' + this.item_share.id;
      if (shareSelector.selected.value === 'Public') {
         this.access = 'View';
         this.forward = false;
         this.link = Path.getAppUrl() + 'share-public/' + this.item_share.id;
      } else if (shareSelector.selected.value === 'Anyone') {
         this.access = 'View';
         this.forward = false;
         this.password = undefined;
         this.checkbox_password = false;
         this.link = linkShare;
      } else {
         this.password = undefined;
         this.checkbox_password = false;
         this.link = linkShare;
      }
      this.shareType = shareSelector.selected.value;
      this.updateHint();
   }

   private updateHint() {
      if (this.shareType === 'Public') {
         this.translate.get('share.public-info').subscribe(s => {
            this.hint = s;
         });
      } else if (this.shareType === 'Anyone') {
         this.translate.get('share.anyone-info').subscribe(s => {
            this.hint = s;
         });
      } else {
         this.translate.get('share.private-info').subscribe(s => {
            this.hint = s;
         });
      }
   }

   shareAccessChange(shareAccess) {
      this.access = shareAccess.selected.value;
   }

   expirationChange(expiration: any, expiry: any) {
      expiry.disabled = !expiration.checked;
      if (expiration.checked) {
         expiry.focus();
         this.expiration = true;
      } else {
         this.expiration = false;
         this.date = undefined;
         this.exp_date = undefined;
      }
   }

   passwordChange(checkpsw: boolean) {
      if (!checkpsw) {
         this.password = undefined;
         this.checkbox_password = false;
      } else {
         this.checkbox_password = true;
      }
   }

   allowShare(item: any) {
      item.allowShare = !item.allowShare;
   }

   downloadChange(download: any) {
      this.pre_download = !download.checked;
   }

   selectChanged(date: any) {
      this.error_date = '';
      const fmt = new MomentPipe();
      this.exp_date = fmt.transform(date.value, 'YYYY-MM-DD') + ' 00:00:00';
   }

   deleteLink() {
      this.service.deleteShare(this.item_share.id, this.isSite,this.data.id)
         .subscribe(data => {
            this.list_people = [];
            this.data.item.shared = false;
            this.dialogRef.close(true);
         }, error => {
            this.data.toast.error(error);
            this.dialogRef.close();
         });
   }

   done(shareWith: string) {
      this.error_date = '';
      this.error_password = '';
      if (this.advanced) {
         if (this.expiration && this.date === undefined
            && this.checkbox_password && (this.password === undefined || this.password === '')) {
            this.translate.get('share.date-require').subscribe(s => {
               this.error_date = s;
            });
            this.translate.get('share.password-require').subscribe(s => {
               this.error_password = s;
            });
         } else if (this.expiration && this.date === undefined) {
            this.translate.get('share.date-require').subscribe(s => {
               this.error_date = s;
            });
         } else if (this.checkbox_password && (this.password === undefined || this.password === '')) {
            this.translate.get('share.password-require').subscribe(s => {
               this.error_password = s;
            });
         } else {
            const en_psw = this.password ? this.password : undefined;
            if(this.isSite) {
               this.service.checkShare(this.list_people, this.data.tin) //Service check member site and outsite
                  .subscribe(
                     data => {
                        if(data.length > 0) {
                           const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                              disableClose: true,
                              data: this
                           });
                           this.translate.get('confirm-shareinfo').subscribe(s => {
                              dialogRef.componentInstance.messageWarning = s;
                              dialogRef.componentInstance.isSubmit = true;
                              dialogRef.componentInstance.isConfirm = true;
                              dialogRef.componentInstance.shareOutList = data;
                           });
                           dialogRef.afterClosed().subscribe(result => {
                              if (result) {
                                 const str = dialogRef.componentInstance.str.toString();
                                 if (str === 'ok') {
                                    this.updateShare(shareWith , en_psw);
                                 }
                              }
                           });
                        } else {
                           this.updateShare(shareWith , en_psw);
                        }
                     }
                  );
            } else {
               this.updateShare(shareWith , en_psw);
            }
         }
      } else {
         this.data.item.shared = true;
         if (this.shareType === 'Public') {
            if (shareWith === 'Done') {
                this.isNotify = true;
            }
            this.service.updateShare(this.item_share.id, this.shareType, this.access,
               this.pre_download, this.exp_date, this.list_people, '', this.forward, this.isSite, this.data.id, this.isNotify)
            .subscribe(res => {   
               this.shareWith(shareWith);
            });
         } else {
            this.shareWith(shareWith);
         }
      }
   }

   updateShare(shareWith: string , en_psw : any){
      this.button.disabled = true;
      this.service.updateShare(this.item_share.id, this.shareType, this.access,
         this.pre_download, this.exp_date, this.list_people, en_psw, this.forward, this.isSite, this.data.id, this.isNotify)
         .subscribe(data => {
            this.error_date = '';
            this.error_password = '';
            this.data.item.shared = true;
            this.button.disabled = false;
            this.shareWith(shareWith);
         }, error2 => this.button.disabled = false);
   }

   shareWith(shareWith: any) {
      switch (shareWith) {
         case  'Email' :
            this.sendEmail();
            break;
         case  'Facebook' :
            this.onFacebook();
            break;
         case  'Twitter' :
            this.onTwitter();
            break;
         default :
            this.dialogRef.close();
            break;
      }
   }

   copyToClipboard(link: any) {
      link.select();
      document.execCommand('copy');
   }

   openWin(url: any, width: number, height: number) {
      const left = Math.round((screen.availWidth - width) / 2);
      const top = Math.round((screen.availHeight - height) / 2);
      const features = 'left=' + left + ',top=' + top + ',width=' + width + ',height=' + height;
      return window.open(url, null, features);
   }

   sendEmail() {
      const dialog = this.dialog.open(ShareToEmailComponent, {
         disableClose: true,
         data: {
            link: this.link,
            service: this.service,
            shareId: this.item_share.id,
            translate: this.translate,
            list_people: this.list_people
         }
      });
   }

   selectSearchItem(item: any) {
      setTimeout(() => {
         this.searchFocused = false;
      }, 100);
      this.peopleId = item.id;
      this.people = item;
   }

   onSearchChange(input: any) {
      this.searchResult = null;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = input.value.trim();
      if (q.length === 0) {
         return;
      }
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(q)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }
      this.timer = setTimeout(() => {
         this.timer = null;

         this.service.share_filter(encodeURIComponent(q), this.data.tin)
            .subscribe(
               data => {
                  if (this.timer == null) {
                     data.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : ((b.name.toUpperCase() > a.name.toUpperCase()) ? -1 : 0));

                     if (this.list_people && this.list_people.length !== 0) {
                        this.list_people.forEach((item1) => {
                           data.forEach((item2, i) => {
                              if (item1.id === item2.id){
                                 data.splice(i, 1);
                              }
                           });
                        });
                     }

                     this.searchResult = data;
                  }
               }, error => {
                  if (error.code === 401) {
                     this.dialogRef.close();
                  }
               });
      }, 300);
   }

   onSearchFocus() {
      this.searchFocused = true;
   }

   onSearchBlur() {
      setTimeout(() => {
         this.searchFocused = false;
      }, 300);
   }

   addPeople(input: any) {
      if (input.value.length > 0) {
         if (this.checkDuplicate(input.value)) {
            this.translate.get('alert.duplicate_username').subscribe(s => {
               this.toast.error(s);
            });
         } else {
            this.checkValidUser(input.value.toLowerCase().trim());
         }
      }
      this.peopleId = '';
      this.people = '';
   }

   checkValidUser(input: string) {
      if (this.searchResult.length > 0) {
         for (let i = 0; i < this.searchResult.length; i++) {
            if (this.searchResult[i].id.toLowerCase().trim() === input) {
               this.peopleId = this.searchResult[i].id;
               this.people = this.searchResult[i];
               if (this.userAllowShare && this.isDisabled) {
                  this.people.access = 'View';
                  this.people.allowShare = false;
                  this.people.isDisabled = true;
               } else {
                  this.people.access = this.access;
                  this.people.allowShare = this.forward;
                  this.people.isDisabled = false;
               }
               this.people.isNew = true;
               this.list_people.push(this.people);
            }
         }
      } else {
         this.service.checkValidShareUser(input).subscribe(data => {
            this.peopleId = data.id;
            this.people = data;
            if (this.userAllowShare && this.isDisabled) {
               this.people.access = 'View';
               this.people.allowShare = false;
               this.people.isDisabled = true;
            } else {
               this.people.access = this.access;
               this.people.allowShare = this.forward;
               this.people.isDisabled = false;
            }
            this.people.isNew = true;
            this.list_people.push(this.people);
         }, () => {
            this.translate.get('alert.invalid_username_only').subscribe(s => {
               this.toast.error(s);
            });
         });
      }
   }

   checkDuplicate(input: string) {
      for (let i = 0; i < this.list_people.length; i++) {
         if (this.list_people[i].id === input) {
            return true;
         }
      }
   }

   cultivoChange(item: any, select) {
      const i = this.list_people.indexOf(item);
      this.list_people[i].access = select.selected.value;
      if (select.selected.value === 'View' || select.selected.value === 'Comment') {
         this.list_people[i].allowShare = false;
      }
   }

   deletePeople(item: any) {
      if (!item.isDisabled || item.isNew) {
         const i = this.list_people.indexOf(item);
         this.list_people.splice(i, 1);
      }
   }

   private getShareUrl(): string {
      return encodeURIComponent(this.service.url + '/share-public/social/' + this.item_share.id);
   }

   onFacebook() {
      const facebookShare = 'https://www.facebook.com/sharer/sharer.php?app_id='
         + this.fb_app_id + '&display=popup&u=' + this.getShareUrl()
         + '&api_key=' + this.app_secret;
      return this.openWin(facebookShare, 670, 450);
   }

   onTwitter() {
      const tweet = 'https://x.com/intent/tweet?text=' + encodeURIComponent(this.data.name) + '&url=' + this.getShareUrl();
      return this.openWin(tweet, 550, 420);
   }
   
   notifyOwnerAferClose() { 
      if (!this.item_share.checkFirstNotify) {
         this.service.notifyShareOwner(this.item_share, this.data, this.list_people).subscribe((data) => {
            if (this.data.component) {
               this.data.component.showdocument.emit();
            }    
         this.dialogRef.close();
         }); 
      } else {
         this.dialogRef.close();
      }
   }
}
